import CheckBox from '../core/Checkbox';
import {
  FieldValues,
  UseControllerProps,
  useController,
  FieldError,
} from 'react-hook-form';

interface InputCheckBoxProps<
  T extends FieldValues,
> extends UseControllerProps<T> {
  label: string;
  editMode?: boolean;
  className?: string;
  error?: FieldError;
  onChange?: () => void;
}

export const InputCheckBox = <T extends FieldValues>({
  editMode,
  label,
  className,
  error,
  onChange,
  ...props
}: InputCheckBoxProps<T>) => {
  const { field } = useController(props);

  return editMode === true ? (
    <CheckBox
      id={field.name}
      label={label}
      checked={field.value}
      onClick={onChange}
      className={className}
      error={error?.message}
      onBlur={() => field.onBlur()}
    />
  ) : (
    <span>{field.value ? 'Ja' : 'Nej'}</span>
  );
};
